import { render } from "./BasketPage.vue?vue&type=template&id=712344df&ts=true"
import script from "./BasketPage?vue&type=script&lang=ts"
export * from "./BasketPage?vue&type=script&lang=ts"

import "@/views/_assets/_verticalApp.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__